module.exports = __webpack_public_path__ + "img/shanghaisxyLogo.be261e73.png";